import axiosInstance from "../axiosInstance";

export const confirmOrder = async (orderId) => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const token = userData?.token;

    const response = await axiosInstance.post(
      "/confirm_order",
      { orderId }, // this is the payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching services data", error);
    throw error;
  }
};

export const getNotificationsAndNewOrder = async (id) => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const token = userData?.token;

    const response = await axiosInstance.post("/get_bell_notification", id, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching services data", error);
    throw error;
  }
};

export const readNotificathion = async (id) => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData"));

    const token = userData?.token;

    const response = await axiosInstance.post("/read_notification", id, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching services data", error);
    throw error;
  }
};
